/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ad_Description_Focus_LabelInputs */



/**
* | output |
* | --- |
* | "Describe in each scene" |
*
* @param {Ad_Description_Focus_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ad_description_focus_label = /** @type {((inputs?: Ad_Description_Focus_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ad_Description_Focus_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Décrivez chaque scène")
	if (locale === "de") return /** @type {LocalizedString} */ ("Beschreiben Sie in jeder Szene")
	if (locale === "it") return /** @type {LocalizedString} */ ("Descrivi in ogni scena")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Опишите каждую сцену.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Describe en cada escena")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("描述每个场景")
	if (locale === "ja") return /** @type {LocalizedString} */ ("各シーンについて説明してください")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रत्येक दृश्य का वर्णन करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Descreva cada cena.")
	return /** @type {LocalizedString} */ ("Describe in each scene")
});